<template>
  <div>
    <h2 class="section-title">Edit my details</h2>
    <div class="row">
      <div class="col-md-8">
        <form>
          <div class="row">
            <div class="col-md-6">
              <div :class="[customer.first_name ? 'show-label' : '', 'form-group']">
                <label>First Name</label>
                <input type="text" class="form-control" placeholder="First Name" v-model="customer.first_name" />
                <h6 class="text-danger small" v-if="formError && typeof formError.first_name !== 'undefined'">{{ formError.first_name }}</h6>
              </div>
            </div>
            <div class="col-md-6">
              <div :class="[customer.last_name ? 'show-label' : '', 'form-group']">
                <label>Last Name</label>
                <input type="text" class="form-control" placeholder="Last Name" v-model="customer.last_name" />
                <h6 class="text-danger small" v-if="formError && typeof formError.last_name !== 'undefined'">{{ formError.last_name }}</h6>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div :class="[customer.phone ? 'show-label' : '', 'form-group']">
                <label>Phone</label>
                <input type="text" class="form-control" placeholder="Phone" v-model="customer.phone" />
                <h6 class="text-danger small" v-if="formError && typeof formError.phone !== 'undefined'">{{ formError.phone }}</h6>
              </div>
            </div>
            <div class="col-md-9">
              <div :class="[customer.email ? 'show-label' : '', 'form-group']">
                <label>Email</label>
                <input type="text" class="form-control" placeholder="Email" v-model="customer.email" />
                <h6 class="text-danger small" v-if="formError && typeof formError.email !== 'undefined'">{{ formError.email }}</h6>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-9">
              <div :class="[customer.address ? 'show-label' : '', 'form-group']">
                <label>Address</label>
                <input type="text" class="form-control" placeholder="Address" v-model="customer.address" />
                <h6 class="text-danger small" v-if="formError && typeof formError.address !== 'undefined'">{{ formError.address }}</h6>
              </div>
            </div>
            <div class="col-md-3">
              <div :class="[customer.postcode ? 'show-label' : '', 'form-group']">
                <label>Postcode</label>
                <input type="text" class="form-control" placeholder="Postcode" v-model="customer.postcode" />
                <h6 class="text-danger small" v-if="formError && typeof formError.postcode !== 'undefined'">{{ formError.postcode }}</h6>
              </div>
            </div>
          </div>
          <div class="form-group">
            <b-btn variant="primary" class="pull-left" @click="editProfile($event)">Update Details</b-btn>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'my-details',
    data () {
      return {
        topError: null,
        formError: null,
        customer: {
          first_name: null,
          last_name: null,
          email: null,
          address: null,
          postcode: null,
          phone: null
        }
      }
    },
    computed: {
      ...mapState({
        token: state => state.token,
        user: state => state.user
      })
    },
    created () {
      this.customer = {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        address: this.user.address1,
        postcode: this.user.postcode,
        phone: this.user.phone
      }
    },
    methods: {
      editProfile (e) {
        e.preventDefault()

        this.$store.dispatch('LoadingOn')
        this.$store.dispatch('EditCustomer', {
          first_name: this.customer.first_name,
          last_name: this.customer.last_name,
          email: this.customer.email,
          phone: this.customer.phone,
          address: this.customer.address,
          postcode: this.customer.postcode
        })
          .then((response) => {
            let kf = this
            setTimeout(function () {
              kf.$store.dispatch('LoadingOff')
              kf.formError = null
              kf.notifyVue('success', 'Your details were successfully saved.')
            }, 1000)
          })
          .catch((error) => {
            this.$store.dispatch('LoadingOff')
            this.formError = {
              'first_name': error.errors.first_name ? error.errors.first_name.join(' ') : null,
              'last_name': error.errors.last_name ? error.errors.last_name.join(' ') : null,
              'email': error.errors.email ? error.errors.email.join(' ') : null,
              'phone': error.errors.phone ? error.errors.phone.join(' ') : null,
              'postcode': error.errors.postcode ? error.errors.postcode.join(' ') : null,
              'address': error.errors.address ? error.errors.address.join(' ') : null
            }

            if (error.errors.top_error) {
              this.registration.topError = error.errors.top_error
            }
          })
      },
      notifyVue (type, message) {
        this.$notifications.notify({
          message: message,
          icon: '',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: type
        })
      }
    }
  }

</script>



// WEBPACK FOOTER //
// my-details.vue?15e2bdd2